import React, { useEffect, useId, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import backend from '../../api/server';

export const SubsidiaryModal = ({ orderId, onHide, show, refresh }) => {
  const [subsidiaries, setSubsidiaries] = useState([]);
  const [selectedSub, setSelectedSub] = useState('');
  const [isProcessing, setIsProcessing] = useState(true);
  const [isError, setIsError] = useState('');
  const formControlId = useId();

  const handleSubmit = async() => {

    if (!selectedSub.length) return;

    setIsProcessing(true);

    const payload = {
      subsidiary_id: selectedSub
    };

    try {
      await backend.put(`/order/${orderId}/subsidiary`, payload);
      onHide?.()
    } catch (error) {
      const msg = error?.response?.data?.msg || error?.message;
      setIsError(msg);
    } finally {
      setIsProcessing(false);
      setSelectedSub('');
      refresh?.();
    }
  };

  useEffect(() => {
    if (show) {
      setIsError('');
      setIsProcessing(true);
      (async () => {
        try {
          const { data } = await backend.get('/subsidiaries');

          setSubsidiaries(data);
        } catch (error) {
          const msg = error?.response?.data?.msg || error?.message;
          setIsError(msg);
          refresh?.();
        } finally {
          setIsProcessing(false);
        }
      })();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Sucursal de la Orden #{orderId}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Elige la sucursal a la que se asignará la orden. Puedes
        cambiarlo en cualquier momento.
        {isProcessing ? (
          <div className="overlay">
            <Spinner animation="border" role="status">
              <span className="sr-only"></span>
            </Spinner>
          </div>
        ) : !!isError ? (
          <div>{isError}</div>
        ) : (
          <Form.Group>
            <Form.Select
              id={formControlId + '-orderSubsidiaries'}
              aria-describedby={
                formControlId + '-orderSubsidiaries'
              }
              onChange={({ target }) => setSelectedSub(target.value)}
              value={selectedSub}
            >
              <option value="">Selecciona una sucursal</option>
              {!!subsidiaries.length &&
                subsidiaries.map(({ id, name }, i) => (
                  <option
                    key={`${formControlId}-${i}-${id}`}
                    value={id}
                  >
                    {name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={isProcessing}
          style={{
            backgroundColor: isProcessing ? '#6c757d' : '#007bff',
          }}
        >
          {isProcessing ? 'Procesando...' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
